import * as consts from '../constants';
import initialState from './initialState';
import * as noAuth from './initialState';

export default function authenticationReducer(state = initialState.authenticationState, action) {
    switch (action.type) {
        case consts.ACTONS.INIT_APP:
            if (action.authenticationState)
                return action.authenticationState;
            return state;
        case consts.ACTONS.LOGIN_SUCCESS:
            return action.authenticationState;
        case consts.ACTONS.LOGOUT_SUCCESS:
            return noAuth.default.authenticationState;

        default:
            return state;
    }
}